<template>
    <div class="login-module">
        <div class="login-tab">
            <!-- <div class="close-btn" @click="close">
          <span class="iconfont icon-a-CombinedShape4" style="font-size: 12px;"></span>
        </div> -->
            <p class="login-textc">修改密码</p>
            <p class="login-texte">SET PASSWORD</p>
            <div class="errorhint" v-show="errorhint">{{errorhinttext}}</div>
            <el-form label-width="80px" :model="editForm" label-position="left" :rules="editFormRules" ref="editForm">
                <el-form-item label="原密码" prop="oldPassword">
                    <el-input @input="amendpasswordClick" @blur="passverify" maxlength="16"
                        v-model="editForm.oldPassword" :type="originalpasswordType" placeholder="请输入原密码"></el-input>
                    <img v-show="isShoweyeyuan==true" v-if="originalpasswordType!=''" class="look"
                        src="../../assets/images/guangbi.png" alt @click="originalshowPassword" />

                    <img v-show="isShoweyeyuan==true" v-else class="look" src="../../assets/images/chakan.png" alt
                        @click="originalshowPassword" />
                    <div class="Inconsistent" v-show="oldpassState">密码错误，请重新输入</div>
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword">
                    <el-popover
                        placement="right"
                        popper-class="passtitleEr"
                        title=""
                        width="200"
                        trigger="click"
                        content="6-16位，且包含大写字母、小写字母、数字、下划线至少三种组合">
                        <el-input slot="reference" @input="amendpasswordClicknnew" maxlength="16" v-model="editForm.newPassword "
                        :type="newpasswordType" placeholder="请输入新密码"></el-input>
                    </el-popover>
                    
                    <img v-show="isShoweyenew==true" v-if="newpasswordType!=''" class="look"
                        src="../../assets/images/guangbi.png" alt @click="newshowPassword" />

                    <img v-show="isShoweyenew==true" v-else class="look" src="../../assets/images/chakan.png" alt
                        @click="newshowPassword" />
                </el-form-item>
                <el-form-item label="确认密码" prop="againpasswordnumber">
                    <el-input @input="amendpasswordClickqr" maxlength="16" v-model="editForm.againpasswordnumber"
                        :type="okqrpasswordType" placeholder="请再次输入密码"></el-input>
                    <img v-show="isShoweyeqr==true" v-if="okqrpasswordType!=''" class="look"
                        src="../../assets/images/guangbi.png" alt @click="okshowPassword" />

                    <img v-show="isShoweyeqr==true" v-else class="look" src="../../assets/images/chakan.png" alt
                        @click="okshowPassword" />
                    <div class="Inconsistent" v-show="inconsistent">两次密码输入不一致</div>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button type="primary" @click="changePassword">完成</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import HintPrompt from "@/components/wx-hintprompt";
    import { login, userById } from "@/api/login";
    import {
        getUuid,
        removeToken,
        removeUuid
    } from "@/utils/auth";
    import {
        checkPassword,
        updatePassword,
    } from "@/api/usermenu";
    export default {
        components: { HintPrompt },
        props: {
            activeName: String,
            loginparameters: {
                type: Object,
                default: () => { },
            },
        },
        data() {
            return {
                logindata: this.loginparameters,
                inconsistent: false,
                hintpromptstate: false, //提示框状态
                markedwords: "", //提示框文字
                errorhint: false,
                errorhinttext: "",
                isShoweye: false,
                againisShoweye: false,
                originalpasswordType: "password",
                newpasswordType: "password",
                okqrpasswordType: "password",
                isShoweyeyuan: false,
                isShoweyenew: false,
                isShoweyeqr: false,
                oldpassState: false,
                editForm: {
                    newPassword: "",
                    oldPassword: "",
                    againpasswordnumber: "",
                    uuid: getUuid(),
                },
                editFormRules: {
                    newPassword: [
                        {
                            required: true,
                            message: "新密码不能为空",
                            trigger: "blur",
                        },
                        {
                            required: true,
                            pattern: "^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_]+$)(?![a-z0-9]+$)(?![a-z\\W_]+$)(?![0-9\\W_]+$)[a-zA-Z0-9\\W_]{6,16}$",
                            message: "密码设置不符合要求",
                            trigger: "blur",
                        },
                    ],
                    oldPassword: [
                        {
                            required: true,
                            message: "原密码不能为空",
                            trigger: "blur",
                        },
                    ],
                    againpasswordnumber: [
                        {
                            required: true,
                            message: "确认密码不能为空",
                            trigger: "blur",
                        },
                    ],
                },
            };
        },
        watch: {
            'editForm.oldPassword': {
                handler(val, oldval) {
                    if (val == '') {
                        this.oldpassState = false;
                    }
                },
                immediate: true,
                deep: true
            }
        },
        computed: {},
        methods: {
            close() {
                this.logindata.logindata = true;
                this.logindata.defaultdata = false;
                this.$store.commit('loginState', false);
            },
            // 提交
            changePassword() {
                if (this.oldpassState) {
                    return
                }
                this.$refs.editForm.validate((valid, value) => {
                    if (valid) {
                        this.$refs.editForm.validateField("againpasswordnumber", () => {
                            if (this.editForm.againpasswordnumber !== this.editForm.newPassword) {
                                this.inconsistent = true;
                            } else {
                                this.inconsistent = false;
                                updatePassword(this.editForm).then((res) => {
                                    if (res.code === 200) {
                                        this.$message({
                                            message: "修改成功",
                                            type: "success",
                                            center: true,
                                        });
                                        this.editForm = {
                                            newPassword: "",
                                            oldPassword: "",
                                            againpasswordnumber: "",
                                            uuid: getUuid(),
                                        };
                                        this.logindata.logindata = true;
                                        this.logindata.forgetdata = false;
                                        this.logindata.settingdata = false;
                                        this.logindata.defaultdata = false;
                                        // this.$store.commit('loginState', true);
                                        this.$store.commit('loginNewState', true);
                                        removeToken();
                                        removeUuid();
                                        localStorage.removeItem('defaultdata')
                                        // localStorage.clear();
                                        // window.location.reload();
                                    } else if (res.code === 1002) {
                                        this.oldpassState = true;
                                    } else if (res.code === 1005) {
                                        this.$message({
                                            message: res.msg,
                                            type: "warning",
                                            center: true,
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            },
            // 验证密码
            passverify() {
                checkPassword(this.editForm.oldPassword).then((res) => {
                    if (res.code === 200) {
                        this.oldpassState = false;
                    } else if (res.code === 1002) {
                        this.oldpassState = true;
                    }
                });
            },
            //显示隐藏密码
            showPassword() {
                this.passwordType === ""
                    ? (this.passwordType = "password")
                    : (this.passwordType = "");
            },

            originalshowPassword() {
                this.originalpasswordType === ""
                    ? (this.originalpasswordType = "password")
                    : (this.originalpasswordType = "");
            },

            newshowPassword() {
                this.newpasswordType === ""
                    ? (this.newpasswordType = "password")
                    : (this.newpasswordType = "");
            },

            okshowPassword() {
                this.okqrpasswordType === ""
                    ? (this.okqrpasswordType = "password")
                    : (this.okqrpasswordType = "");
            },
            //修改登录密码
            amendpasswordClick() {
                // console.log(this.editForm.newPassword);
                // console.log(this.editForm.againpasswordnumber);
                // console.log(this.editForm.oldPassword);

                if (
                    this.editForm.newPassword != "" &&
                    this.editForm.againpasswordnumber != "" &&
                    this.editForm.oldPassword != ""
                ) {
                    this.amendpassword = false;
                } else {
                    this.amendpassword = true;
                }

                this.isShoweyeyuan = false;
                this.inconsistent = false;
                if (this.editForm.oldPassword == "") {
                    this.isShoweyeyuan = false;
                    this.passwordType = "password";
                } else {
                    this.isShoweyeyuan = true;
                }
            },

            amendpasswordClicknnew() {
                if (
                    this.editForm.newPassword != "" &&
                    this.editForm.againpasswordnumber != "" &&
                    this.editForm.oldPassword != ""
                ) {
                    this.amendpassword = false;
                } else {
                    this.amendpassword = true;
                }
                this.isShoweyenew = false;
                this.inconsistent = false;
                if (this.editForm.newPassword == "") {
                    this.isShoweyenew = false;
                    this.passwordType = "password";
                } else {
                    this.isShoweyenew = true;
                }
            },
            amendpasswordClickqr() {
                if (
                    this.editForm.newPassword != "" &&
                    this.editForm.againpasswordnumber != "" &&
                    this.editForm.oldPassword != ""
                ) {
                    this.amendpassword = false;
                } else {
                    this.amendpassword = true;
                }
                this.isShoweyeqr = false;
                this.inconsistent = false;
                if (this.editForm.againpasswordnumber == "") {
                    this.isShoweyeqr = false;
                    this.passwordType = "password";
                } else {
                    this.isShoweyeqr = true;
                }
            },
        },
        mounted() { },
        destroyed() { },
        created() { },
        updated() { },
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import './index.styl';
</style>


// WEBPACK FOOTER //
// src/components/setpassword/index.vue